import { COMMON_CONSTANTS, getTranslatedText } from '@nile/components';

const GLOBAL_AI_BOT_STATE = {
  exit: 'Exit',
  entry: 'Entry',
  Arrow_Entry: 'Arrow_Entry',
  Bot_Entry: 'Bot_Entry',
  Search: 'Search',
  Idle: 'Idle',
  Happy: 'Happy'
};

const AI_BOT_STATE = {
  loading: 'Search',
  success: 'Happy',
  exit: 'Exit',
  entry: 'Entry',
  idle: 'Idle',
  active: 'Active'
};

const AI_FEEDBACK_TYPES = {
  COPY_PASTE: 'COPY_PASTE',
  HELPFUL: 'HELPFUL',
  NOT_HELPFUL: 'NOT_HELPFUL'
};

const getAIRephraseKeys = (intl) => {
  const successText = [
    getTranslatedText(intl, 'msp.ai.rephrase.success.message.1'),
    getTranslatedText(intl, 'msp.ai.rephrase.success.message.2'),
    getTranslatedText(intl, 'msp.ai.rephrase.success.message.3'),
    getTranslatedText(intl, 'msp.ai.rephrase.success.message.4')
  ];

  const loadingText = [
    getTranslatedText(intl, 'msp.ai.rephrase.loading.message.1'),
    getTranslatedText(intl, 'msp.ai.rephrase.loading.message.2'),
    getTranslatedText(intl, 'msp.ai.rephrase.loading.message.3')
  ];

  return { successText, loadingText };
};

const AI_ERROR_CODE = {
  50001: 'app.errorCode.50001', // Rate limit error
  50002: 'app.errorCode.50002', // Worklog summary  empty
  50003: 'app.errorCode.50003', // Summary empty
  50004: 'app.errorCode.50004' // Summary empty
};

const BETA_AI_FEATURE_GROUP_IDS = [
  '2969588073640759303',
  '2969588073640759305'
];

// featureId: featureConstant
const BETA_AI_FEATURES = {
  '3': 'WORKLOG_SUMMARIZATION',
  '4': 'TICKETS_SUMMARY_BY_CATEGORY',
  '5': 'WORKLOG_NOTE_COMPOSE',
  '6': 'RECOMMENDED_SOLUTION',
  '9': 'SIMILAR_TICKETS',
  '8': 'AI_WEB_SEARCH',
  '10': 'SCRIPT_GENERATION'
};

const AI_AGENTS_CONSTANT_FEATURE_ID_MAP = {
  TICKET_CONVERSATION_SUMMARIZE: '1',
  SIDE_CONVERSATION_COMPOSE: '2',
  WORKLOG_SUMMARIZATION: '3',
  TICKETS_SUMMARY_BY_CATEGORY: '4',
  WORKLOG_NOTE_COMPOSE: '5',
  RECOMMENDED_SOLUTION: '6',
  REAL_TIME_ALERTS: '7',
  WEB_SEARCH: '8',
  SIMILAR_TICKETS: '9',
  SCRIPT_GENERATION: '10',
  KNOWLEDGE_BASE: '11',
  TICKET_DEFLECTION: '12',
  PROMPT_BUILDER: '13',
  TICKET_TRIAGE: '14',
  PATCH_AGENT: '15'
};

const AI_AGENTS_MAP = {
  TICKET_CONVERSATION_SUMMARIZE: 'TICKET_CONVERSATION_SUMMARIZE',
  SIDE_CONVERSATION_COMPOSE: 'SIDE_CONVERSATION_COMPOSE',
  WORKLOG_SUMMARIZATION: 'WORKLOG_SUMMARIZATION',
  TICKETS_SUMMARY_BY_CATEGORY: 'TICKETS_SUMMARY_BY_CATEGORY',
  WORKLOG_NOTE_COMPOSE: 'WORKLOG_NOTE_COMPOSE',
  RECOMMENDED_SOLUTION: 'RECOMMENDED_SOLUTION',
  REAL_TIME_ALERTS: 'REAL_TIME_ALERTS',
  WEB_SEARCH: 'WEB_SEARCH',
  SIMILAR_TICKETS: 'SIMILAR_TICKETS',
  SCRIPT_GENERATION: 'SCRIPT_GENERATION',
  KNOWLEDGE_BASE: 'KNOWLEDGE_BASE',
  TICKET_DEFLECTION: 'TICKET_DEFLECTION',
  PROMPT_BUILDER: 'PROMPT_BUILDER',
  TICKET_TRIAGE: 'TICKET_TRIAGE',
  PATCH_AGENT: 'PATCH_AGENT'
};

const AI_IN_TICKET_DETAILS = [
  {
    id: 'TICKET_AI_SUMMARY',
    featureName: AI_AGENTS_MAP.TICKET_CONVERSATION_SUMMARIZE,
    label: 'ai.summary.cta',
    icon: 'AI_TICKET',
    disabledTooltip: 'msp.ai.ticket.summary.disabled.tooltip.message'
  },
  {
    id: 'TICKET_SIDE_CONVERSATION',
    featureName: AI_AGENTS_MAP.SIDE_CONVERSATION_COMPOSE,
    label: 'msp.ai.feature.vendor.conversation.compose',
    icon: 'AI_MAIL',
    roleToCheck: ['tickets.edit'],
    disabledTooltip: 'msp.ai.ticket.side.conversation.disabled.tooltip.message'
  },
  {
    id: 'WORKLOG_SUMMARIZATION',
    featureName: AI_AGENTS_MAP.WORKLOG_SUMMARIZATION,
    label: 'msp.ai.feature.worklog.summary',
    icon: 'AI_WORKLOG',
    roleToCheck: ['tickets.edit'],
    disabledTooltip: 'msp.ai.ticket.worklog.summary.disabled.tooltip.message'
  },
  {
    id: 'SIMILAR_TICKETS',
    featureName: AI_AGENTS_MAP.SIMILAR_TICKETS,
    label: 'msp.ai.feature.similar.tickets',
    icon: 'AI_TICKET',
    roleToCheck: ['tickets.edit'],
    disabledTooltip: 'msp.ai.similar.tickets.disabled.tooltip.message',
    progressTooltip: 'msp.ai.activation.progress.tooltip'
  },
  {
    id: 'RECOMMENDED_SOLUTION',
    featureName: AI_AGENTS_MAP.RECOMMENDED_SOLUTION,
    label: 'msp.ai.feature.recommended.solutions',
    icon: 'AI_Bulb',
    roleToCheck: ['tickets.edit'],
    disabledTooltip: 'msp.ai.recommended.solutions.disabled.tooltip.message',
    progressTooltip: 'msp.ai.activation.progress.tooltip'
  },
  {
    id: 'KNOWLEDGE_BASE',
    featureName: AI_AGENTS_MAP.KNOWLEDGE_BASE,
    label: 'msp.ai.feature.knowledge.base.name',
    icon: 'AI_KB',
    roleToCheck: ['knowledgeBase.add'],
    disabledTooltip: 'msp.ai.knowledge.base.disabled.tooltip.message',
    progressTooltip: 'msp.ai.knowledge.base.progress.tooltip'
  }
];

export {
  AI_BOT_STATE,
  AI_FEEDBACK_TYPES,
  getAIRephraseKeys,
  AI_ERROR_CODE,
  GLOBAL_AI_BOT_STATE,
  BETA_AI_FEATURE_GROUP_IDS,
  BETA_AI_FEATURES,
  AI_IN_TICKET_DETAILS,
  AI_AGENTS_CONSTANT_FEATURE_ID_MAP,
  AI_AGENTS_MAP
};
